export default {
    message: "Az alábbiakban felsorolt termékek elfogytak, és eltávolították a kosárból. Kérjük, válasszon mást.",
    buttons: {
        ok: "Rendben"
    }
}